import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Callback from './views/Callback.vue';
import Start from './views/Start.vue';
import Activate from './views/Activate.vue';
import Payment from './views/Payment.vue';
import Billing from './views/Billing.vue';
import BillingItem from './views/BillingItem.vue';
import AccountPage from './views/AccountPage.vue';
import EditContact from './views/EditContact.vue';
import Authentication from './views/Authentication.vue';
import Welcome from './views/WelcomePage.vue';
import FAQs from './views/FAQs.vue';
import Action from './views/Action.vue';
import SchemaSurvey from './views/SchemaSurvey.vue';

import * as auth from './libs/AuthService';

Vue.use(Router);

const requireAuth = (to, from, next) => {
  auth.requireAuth(to, from, next);
};

const logout = () => {
  auth.logout();
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: requireAuth,
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome,
    },
    {
      path: '/activate',
      name: 'activate',
      component: Activate,
      beforeEnter: requireAuth,
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment,
      beforeEnter: requireAuth,
    },
    {
      path: '/billing',
      name: 'billing',
      component: Billing,
      beforeEnter: requireAuth,
    },
    {
      path: '/billing/:id',
      name: 'billing',
      component: BillingItem,
      beforeEnter: requireAuth,
    },
    {
      path: '/account',
      name: 'account',
      component: AccountPage,
      beforeEnter: requireAuth,
    },
    {
      path: '/contact/:id',
      name: 'contact',
      component: EditContact,
      beforeEnter: requireAuth,
    },
    {
      path: '/new-user',
      name: 'NewUser',
      component: Home,
      beforeEnter: requireAuth,
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback,
    },
    {
      path: '/logout',
      name: 'Logout',
      beforeEnter: logout,
    },
    {
      path: '/start',
      name: 'start',
      component: Start,
      beforeEnter: requireAuth,
      meta: { noNavBar: true },
    },
    {
      path: '/authentication',
      name: 'authentication',
      component: Authentication,
      beforeEnter: requireAuth,
    },
    {
      path: '/faqs',
      name: 'faqs',
      component: FAQs,
    },
    {
      path: '/actions/add',
      name: 'addAction',
      component: Action,
      beforeEnter: requireAuth,
    },
    {
      path: '/actions/:id',
      name: 'editAction',
      component: Action,
      beforeEnter: requireAuth,
    },
    {
      path: '/schema-survey',
      name: 'schemaSurvey',
      component: SchemaSurvey,
      beforeEnter: requireAuth,
    },
  ],
});
